import { useQuery } from "@tanstack/react-query";
import apiClient from "../client";

// Org-wide letter print-layout settings (mm). Shared by every admin's letter print and by
// the Settings editor. apiClient injects the auth header and handles 401s.
const useLetterSettingsQuery = () =>
  useQuery({
    queryKey: ["letter-settings"],
    queryFn: () =>
      apiClient.get("/admin/letter-settings").then((res) => res.data?.data),
    staleTime: 5 * 60 * 1000,
  });

export default useLetterSettingsQuery;
